/**
 * Match-day photo albums, watermarked and hosted in the public `match-photos` Supabase
 * storage bucket at `<path>/<album key>/<name>.jpg`, with thumbnails in `thumbs/<name>.webp`.
 */
export const PHOTO_WEEKS = [
  {
    week: 1,
    label: "Week 1",
    season: "Season 3",
    path: "season-3/week-1",
    albums: [
      {
        key: "div-1",
        division: "DIV 1",
        photos: [
          "DSC00006", "DSC00007", "DSC00011", "DSC00018", "DSC00031", "DSC00038",
          "DSC00039", "DSC00049", "DSC00052", "DSC00058", "DSC00059", "DSC00062",
          "DSC00067", "DSC00075", "DSC00080", "DSC00082", "DSC00087", "DSC00091",
          "DSC00094", "DSC00101", "DSC00106", "DSC00108", "DSC00112", "DSC00119",
          "DSC00126", "DSC00130", "DSC00134", "DSC00136", "DSC00137", "DSC00139",
          "DSC00145", "DSC00147", "DSC00151", "DSC00153", "DSC00155", "DSC00158",
          "DSC00162", "DSC00168", "DSC00170", "DSC00177", "DSC00179", "DSC00180",
          "DSC00183", "DSC00185", "DSC00188", "DSC00202", "DSC00205", "DSC00210",
          "DSC00217", "DSC00221", "DSC00232", "DSC00234", "DSC00239", "DSC00241",
          "DSC00247", "DSC00248", "DSC00249", "DSC00251", "DSC00254", "DSC00255",
          "DSC00257", "DSC00259", "DSC00260", "DSC00261", "DSC00271", "DSC00272",
          "DSC00275", "DSC00276", "DSC00278", "DSC00283", "DSC00285", "DSC00289",
          "DSC00290", "DSC00291", "DSC00292", "DSC00293", "DSC00294", "DSC00295",
          "DSC00296", "DSC00298", "DSC00300", "DSC00303", "DSC00304", "DSC00305",
          "DSC00309", "DSC00311", "DSC00317", "DSC00318", "DSC00321", "DSC00327",
          "DSC00334", "DSC00337", "DSC00341", "DSC00345", "DSC00347", "DSC00350",
          "DSC00352", "DSC00353", "DSC00360", "DSC00364", "DSC00367", "DSC00369",
          "DSC00370", "DSC00373", "DSC00379", "DSC00382", "DSC00385", "DSC00387",
          "DSC00388", "DSC00393", "DSC00400", "DSC00402", "DSC00406", "DSC00410",
          "DSC00416", "DSC00426", "DSC00430", "DSC00434", "DSC00442", "DSC00446",
          "DSC00451", "DSC00454", "DSC00465", "DSC00486", "DSC00488", "DSC00494",
          "DSC00498", "DSC00504", "DSC00515", "DSC00518", "DSC00528", "DSC00532",
          "DSC00534", "DSC00537", "DSC00539", "DSC00541", "DSC00545", "DSC00546",
          "DSC00557", "DSC00561", "DSC00564", "DSC00579", "DSC00594", "DSC00598",
          "DSC00601", "DSC00603", "DSC00604", "DSC00608", "DSC00611", "DSC00614",
          "DSC00617", "DSC00618", "DSC00623", "DSC00625", "DSC00631", "DSC00636",
          "DSC00639", "DSC00642", "DSC00646", "DSC00654", "DSC00658", "DSC00660",
          "DSC00663", "DSC00664", "DSC00665", "DSC00691", "DSC00708", "DSC00729",
          "DSC00730", "DSC00731", "DSC00732", "DSC00734", "DSC00742", "DSC00750",
          "DSC00752", "DSC00756", "DSC00761", "DSC00764", "DSC00774", "DSC00790",
          "DSC00795", "DSC00802", "DSC00827", "DSC00835", "DSC00838", "DSC00845",
          "DSC00850", "DSC00853", "DSC00856", "DSC00860", "DSC00885", "DSC00887",
          "DSC00901", "DSC00908", "DSC00918", "DSC09992",
        ],
      },
      {
        key: "div-2",
        division: "DIV 2",
        photos: [
          "DSC01629", "DSC01632", "DSC01636", "DSC01637", "DSC01640", "DSC01643",
          "DSC01647", "DSC01649", "DSC01652", "DSC01654", "DSC01657", "DSC01667",
          "DSC01670", "DSC01675", "DSC01679", "DSC01681", "DSC01684", "DSC01694",
          "DSC01700", "DSC01709", "DSC01712", "DSC01716", "DSC01720", "DSC01722",
          "DSC01729", "DSC01734", "DSC01735", "DSC01737", "DSC01739", "DSC01742",
          "DSC01746", "DSC01747", "DSC01750", "DSC01757", "DSC01760", "DSC01762",
          "DSC01764", "DSC01768", "DSC01773", "DSC01776", "DSC01777", "DSC01783",
          "DSC01799", "DSC01812", "DSC01840", "DSC01847", "DSC01852", "DSC01855",
          "DSC01857", "DSC01862", "DSC01864", "DSC01865", "DSC01867", "DSC01871",
          "DSC01875", "DSC01880", "DSC01884", "DSC01896", "DSC01899", "DSC01912",
          "DSC01920", "DSC01926", "DSC01928", "DSC01930", "DSC01931", "DSC01934",
          "DSC01939", "DSC01941", "DSC01949", "DSC01951", "DSC01953", "DSC01956",
          "DSC01958", "DSC01961", "DSC01963", "DSC01966", "DSC01967", "DSC01970",
          "DSC01974", "DSC01976", "DSC01982", "DSC01984", "DSC01989", "DSC01991",
          "DSC01998", "DSC02002", "DSC02005", "DSC02015", "DSC02017", "DSC02022",
          "DSC02025", "DSC02033", "DSC02040", "DSC02042", "DSC02047", "DSC02058",
          "DSC02059", "DSC02062", "DSC02066", "DSC02067", "DSC02069", "DSC02070",
          "DSC02074", "DSC02076", "DSC02079", "DSC02082", "DSC02085", "DSC02086",
          "DSC02104", "DSC02113", "DSC02119", "DSC02121", "DSC02127", "DSC02134",
          "DSC02139", "DSC02141", "DSC02144", "DSC02146", "DSC02159", "DSC02173",
          "DSC02188", "DSC02198",
        ],
      },
      {
        key: "35-plus",
        division: "35+",
        photos: [
          "DSC00923", "DSC00926", "DSC00928", "DSC00933", "DSC00942", "DSC00947",
          "DSC00951", "DSC00955", "DSC00963", "DSC00970", "DSC00979", "DSC00989",
          "DSC00995", "DSC01002", "DSC01005", "DSC01012", "DSC01026", "DSC01034",
          "DSC01040", "DSC01044", "DSC01046", "DSC01049", "DSC01054", "DSC01061",
          "DSC01067", "DSC01071", "DSC01077", "DSC01081", "DSC01084", "DSC01087",
          "DSC01092", "DSC01096", "DSC01099", "DSC01105", "DSC01109", "DSC01116",
          "DSC01124", "DSC01126", "DSC01131", "DSC01132", "DSC01140", "DSC01150",
          "DSC01152", "DSC01153", "DSC01162", "DSC01166", "DSC01181", "DSC01194",
          "DSC01198", "DSC01201", "DSC01205", "DSC01213", "DSC01220", "DSC01230",
          "DSC01240", "DSC01249", "DSC01255", "DSC01256", "DSC01267", "DSC01271",
          "DSC01276", "DSC01284", "DSC01287", "DSC01298", "DSC01299", "DSC01307",
          "DSC01310", "DSC01315", "DSC01335", "DSC01338", "DSC01344", "DSC01352",
          "DSC01356", "DSC01359", "DSC01362", "DSC01364", "DSC01376", "DSC01382",
          "DSC01384", "DSC01503", "DSC01505", "DSC01515", "DSC01518", "DSC01523",
          "DSC01524", "DSC01528", "DSC01530", "DSC01535", "DSC01539", "DSC01552",
          "DSC01553", "DSC01561", "DSC01566", "DSC01569", "DSC01571", "DSC01574",
          "DSC01577", "DSC01605", "DSC01609", "DSC01613", "DSC01615", "DSC01621",
        ],
      },
    ],
  },
];
